"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Last Viewed Position of VOD and SoCu content
 * REST API definition to store/retrieve/delete Last viewed position of a VOD and SoCu content of an account using bodyId.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: team-cumulus@xperi.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error415CodeEnum = void 0;
exports.Error415CodeEnum = {
    ApigwError: 'APIGW_ERROR',
    UnsupportedMediaType: 'UNSUPPORTED_MEDIA_TYPE'
};
